module.exports = __webpack_public_path__ + "img/gr.e8c26c8.svg";